import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import Cookies from "universal-cookie";
import { Transition } from "@headlessui/react";
import { StyleSheet } from "@react-pdf/renderer";
import { PDFViewer, PDFDownloadLink, Page, Text, Document, View } from "@react-pdf/renderer";
import {
  CheckCircleIcon,
  DocumentCheckIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/24/outline";
import Layout from "../Layout";
import Header from "../components-layout/Header";
import WarningModal from "../components-modals/WarningModal";
import Container from "../components-layout/Container";
import { useSecciones } from "../vistaAsistencia/hooks/useSecciones";
import { useNiveles } from "../vistaAsistencia/hooks/useNiveles";
import { useGrados } from "../vistaAsistencia/hooks/useGrados";
import { useSedes } from "../vistaAsistencia/hooks/useCampus";
import { callCiclo } from "../asignacion-horario/services/Asignacion.service";
import { TipoReporteSabana, TipoVista } from "../vistaAsistencia/components/comboMeses";
import ComboDato from "../vistaAsistencia/components/ComboDato";
import { ComboMeses } from "../vistaAsistencia/components/comboMeses";
import useUnidades from "./hooks/useUnidades";
import SwitchComponent from "./components/SwitchComponent";
import { get } from "../asignacion-horario/services/General.service";
import { getData } from "./services/sabana.service";


const SabanaNotasIndex = () => {

    const cookies = new Cookies();
    //const url = cookies.get("__urlSchoolApi"); // url para enviar al api viene de cookies
    const urlState = useSelector(state => state.url.urlSchoolApi)
    const url = urlState === '' || urlState === undefined || urlState === null ? cookies.get("__urlSchoolApi") : urlState
    const { headersAPI: headers } = useSelector((state) => state.url); // Headers para enviar al api viene de redux
    const IdEmp = useSelector((state) => state.auth.IdEmp);
    const user = useSelector((state) => state.auth.user);
    const sede = useSelector((state) => state.auth.IdSede);
    const userObj = JSON.parse(user);
    const sedesRef = useRef(null);
    const [loading, setLoading] = useState(false);
    userObj.LoginId = userObj.LoginId.split(" ")  
    .map((x) => {
      return x.charAt(0).toUpperCase() + x.slice(1).toLowerCase();
    })
    .join(" ");
    //Manejo de errores
    const [modal, setModal] = useState({
      show: false,
      msg: "",
      ok: false,
    });
    const [esNotaFinal, setEsNotaFinal] = useState(false);
    const [incluirNivelacion, setIncluirNivelacion] = useState(false);
    const [idSede, setIdSede] = useState("");
    const [idNivel, setIdNivel] = useState("");
    const [idGrado, setIdGrado] = useState("");
    const [idUnidad, setIdUnidad] = useState("");
    const [idSeccion, setIdSeccion] = useState("");
    const [tipoReporte, setTipoReporte] = useState("0")
    const [idMes, setIdMes] = useState(0)
    const [secciones, setSecciones] = useSecciones([], idSede, idGrado)
    const [ciclo, setCiclo] = useState(2024);
    const [sedes] = useSedes([])
    const [datosTipos, setDatosTipos] = useState([]);
    const [niveles, setNiveles] = useNiveles([], idSede);
    const [grados, setGrados ] = useGrados([], idSede, idNivel);
    const [nombreMes, setNombreMes] = useState("")
    const [listaFaltas , setListaFaltas] = useState([])
    const [month, setMonth] = useState(1)
    const [year, setYear] = useState(2024)
    const [subtituloTipos, setSubtituloTipos] = useState("");
    const [unidades, setUnidades] = useState([]);
    const [reporteData, setReporteData] = useState({})
    
    const [reporteDatos, setReporteDatos] = useState()
    const searchParams = ["Carnet", "NombreCompleto"];

    useEffect(() => {
      setReporteDatos([])
      setListaFaltas([])
      
    }, [idSede, idMes, idNivel, idGrado, idSeccion])
    const [controlesBloqueados, setControlesBloqueados] = useState(false);
    const handleMesChange = (e) => {
      let meses = {
        1:"Enero",
        2:"Febrero",
        3:"Marzo",
        4:"Abril",
        5:"Mayo",
        6:"Junio",
        7:"Julio",
        8:"Agosto",
        9:"Septiembre",
        10:"Octubre",
        11:"Noviembre",
        12:"Diciembre",
      }
      setNombreMes(meses[e.target.value || 1])
      setIdMes(() => parseInt(e.target.value))
    }

    const obtenerReporte = async () => {
      let comprobador = true

      if(comprobador) {
          setLoading(true)
          setListaFaltas([])
          setReporteDatos([])
          
          
      
          const objetoDetalle = {
            "IdCiclo" : ciclo,
            "IdSede" : idSede,
            "IdGrado" : idGrado,
            "IdSeccion" : idSeccion,
            "IdUnidad" : idUnidad,
            "IdNivelacion" : "NO",
            "IdTrimestre": 0,
            "Recuperacion": "NO",
            "Mineduc": tipoReporte
          }
      
          
          
          //const objetoEnvio = tipoReporte === "1" ? objetoDetalle: objetoResumen
          try {
              const data = await getData(url + '/reportes/sabana_notas', headers, objetoDetalle)
              // getData = async ( url, headers, contentParam )
              setReporteData(data.msg);
              console.log(data)
              //setReporteDatos(data.msg);
              setLoading(false)
          } catch (error) {
              setLoading(false)
              setModal({
                show:true,
                ok:false,
                msg: "No se pudo obtener la información",
              })
          }
      }else{
          setModal({
            ok:false,
            show:true,
            msg: "Ingrese todos los datos de búsqueda"
          })
      }
    }
  
    useEffect(() => {
      setListaFaltas([])
      setDatosTipos([])
    }, [tipoReporte])
    
    const handleSede = (e) => {
      // combo para obtrener los values de los combos
      setNiveles([]);
      setGrados([]);
      setSecciones([]);
      setIdSede(e.target.value);
      setIdNivel("")
      setIdGrado("")
      setIdSeccion("");
    };

    const handleNivel = (e) => {
      setGrados([]);
      setSecciones([]);
      setIdNivel(e.target.value);
      setIdGrado("")
      setIdSeccion("");
    };
  
    const handleGrado = (e) => {
      setSecciones([]);
      setIdNivel(e.target.value);
      setIdGrado(e.target.value);
      setIdSeccion("");
    };
  
    const handleSeccion = (e) => {
      setIdSeccion(e.target.value);
    };
  
    const handleUnidad = (e) => {
      setIdUnidad(e.target.value)
    }

    const getCiclo = async () => {
      const ciclo = await callCiclo(url, headers)
      setCiclo(ciclo)
    }
/*
GET /schoolapi/utils/busquedas
 
{
  "opcion": "CAT_UNIDADES",
  "idgrado": "0101",
  "Idsede": "01"
}
*/
    const getUnidades = async () => {
      let objeto = {
        "opcion": "CAT_UNIDADES",
        "idgrado": idGrado,
        "Idsede": idSede
      }
      const unidades = await get(url + "/utils/busquedas", headers, objeto);
      setUnidades(unidades);
    }
  
    useEffect(() => {
      getUnidades()
    }, [idSeccion])
    
    useEffect(() => {
      console.log('esNotaFinal: ', esNotaFinal)
    }, [esNotaFinal])
    
    const handleSwitchEnabled = (e) => {
      setEsNotaFinal(e)
    }

    const handleNivelacionEnabled = (e) => {
      setIncluirNivelacion(e)
    }

  useEffect(() => {
    setMonth(new Date().getMonth() + 1)
    setYear(new Date().getFullYear())
    getCiclo()
  }, []);

  return (
    <>
          <WarningModal
        open={loading ? true : false}
        image={<img src="./img/loader.gif" alt="loading" />}
        opacity="bg-opacity-100"
      />
      <Transition show={true}>
        <Layout userObj={userObj} activeTab="Alumnos">
          <Container className={"w-full p-2 lg:p-8"}>
            <Header title="Sabana de notas" logo={DocumentCheckIcon} />
            <WarningModal
              open={modal.show ? true : false}
              image={
                modal.ok ? (
                  <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto" />
                ) : (
                  <ExclamationCircleIcon className="h-20 w-20 text-red-500 mx-auto" />
                )
              }
              title={"Aviso"}
              subtitle={<span>{modal.msg}</span>}
              opacity="bg-opacity-50"
            >
              <div className="mt-5 sm:mt-6">
                <button
                  onClick={() => {
                    if (modal.reload) {
                      window.location.reload();
                    }
                    setModal((curr) => ({
                      ...curr,
                      show: false,
                      reload: true,
                    }));
                  }}
                  type="button"
                  className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
                >
                  Entendido
                </button>
              </div>
            </WarningModal>
            <div className="w-full  flex-col xl:flex-row flex bg-primarioMira rounded-lg ">
              <div className="basis-1/4  bg-primarioMira m-2 rounded-br-lg">
                <Transition
                  className="flex flex-col bg-secundarioMira rounded-lg shadow-sm shadow-white"
                  show={true}
                >
              <div className="basis-1/4 p-2 bg-secundarioMira m-2  rounded-lg shadow-sm shadow-white">
                  <label className="text-white font-medium mb-4 ">Datos de búsqueda</label>
                <>
                <div className="flex flex-col">
                  <div className="flex flex-col">
                    <div className="flex flex-col lg:w-full mt-1">
                      <label className="mb-1 text-gray-100 text-sm"></label>
                      <div className="border border-gray-100 p-2 rounded">
                      <TipoReporteSabana setTipoReporte={setTipoReporte} tipoReporte={tipoReporte}/>
                      </div>
                    </div>
                  </div>
                  
                </div>
                <div className="flex flex-col">
                  <label className="text-white text-sm ">Sede</label>
                  <select
                    id="idSede"
                    ref={sedesRef}
                    onChange={(e) => handleSede(e)}
                    name="IdSede"
                    type="select"
                    disabled={controlesBloqueados}
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                  >
                    <option value="">---Selecciona Sede---</option>
                    {sedes.map((sede) => (
                      <option key={sede.IdSede} value={sede.IdSede}>
                        {sede.Sede}
                      </option>
                    ))}
                  </select>
                </div>
                <label className="text-white text-sm ">Nivel</label>
                <ComboDato
                  name={"IdNivel"}
                  textoDefault={"---Selecciona Nivel---"}
                  arr={niveles}
                  value={"IdNivel"}
                  text={"Nivel"}
                  handler={handleNivel}
                />

                <label className="text-white text-sm ">Grado</label>
                <ComboDato
                  name={"IdGrado"}
                  textoDefault={"---Selecciona Grado---"}
                  arr={grados}
                  value={"IdGrado"}
                  text={"Grado"}
                  handler={handleGrado}
                />
                <label className="text-white text-sm ">Sección</label>
                <ComboDato
                  name={"IdSeccion"}
                  textoDefault={"---Selecciona Sección---"}
                  arr={secciones}
                  value={"IdSeccion"}
                  text={"Seccion"}
                  handler={handleSeccion}
                />
                {(unidades.length > 0 && tipoReporte === "0" ) && (
                  <>
                    <label className="text-white text-sm ">Unidades</label>
                    <ComboDato
                    name={"IdUnidad"}
                    textoDefault={"---Selecciona Unidad---"}
                    arr={unidades}
                    value={"IdUnidad"}
                    text={"NombreUnidad"}
                    handler={handleUnidad}
                    />
                    <div className="flex flex-row justify-between">
                      <SwitchComponent handleEnabled={handleSwitchEnabled} enabled={esNotaFinal} text={"Nota final"}/>
                      <SwitchComponent handleEnabled={handleNivelacionEnabled} enabled={incluirNivelacion} text={"Incluir nivelación"}/>
                    </div>
                  </>
                )}
                {tipoReporte === "1" &&
                <SwitchComponent handleEnabled={handleNivelacionEnabled} enabled={incluirNivelacion} text={"Sabana de recuperación"}/>
                }

                  <div className="my-2 mt-4">
                    {idSeccion && (
                      <button 
                      className="transition duration-200 hover:bg-transparent hover:border-azulBrillanteMira border p-2 bg-azulBrillanteMira text-white w-full rounded-md focus:shadow"
                      onClick={() => obtenerReporte()}>Buscar</button>
                    )}
                  </div>
                </>
                </div>
                </Transition>

              </div>
              <div className="basis-3/4">
              
                <div className="flex w-full">
                  <PDFViewer width={"100%"} height={"100%"} showToolbar={true}>
                    <Document>
                        <Page orientation="landscape" size="LETTER" style={{ padding: "8"}}>
                            <View style={styles.col}>

                                <View style={styles.row} >
                                  <Text style={styles.headerText}>NOTAS POR GRADO Mineduc</Text> 
                                  <Text style={styles.headerText}>Colegio de Informatica IMB-PC</Text>
                                  <Text style={styles.headerText}>Sede: San Cristóbal</Text>
                                </View>

                                <View style={styles.containerColBorder}>
                                    <View style={ styles.col}>
                                        <View style={ styles.row}>
                                            <View style={styles.rowCenter}>
                                                <Text style={styles.containerTextBold}>Grado:</Text>
                                                <Text style={styles.containerText}>Primero</Text>
                                            </View>
                                            <View style={styles.rowCenter}>
                                                <Text style={styles.containerTextBold}>Sección:</Text>
                                                <Text style={styles.containerText}>A</Text>
                                            </View>
                                            <View style={styles.rowCenter}>
                                                <Text style={styles.containerTextBold}>Jornada:</Text>
                                                <Text style={styles.containerText}>Matutina</Text>
                                            </View>
                                            <View style={styles.rowCenter}>
                                                <Text style={styles.containerTextBold}>Ciclo:</Text>
                                                <Text style={styles.containerText}>2024</Text>
                                            </View>
                                            <View style={styles.rowCenter}>
                                                <Text style={styles.containerTextBold}>Unidad:</Text>
                                                <Text style={styles.containerText}>Nota final 2024</Text>
                                            </View>
                                        </View>
                                        <View style={ styles.row }>
                                            <View style={{ marginTop:"8" }}>
                                                <View style={styles.rowCenter}>
                                                    <Text style={styles.containerTextBold}>Carrera:</Text>
                                                    <Text style={styles.containerText}>Ciclo de Educación básica o Cultura General</Text>
                                                </View>
                                            </View>
                                        </View>
                                    </View>
                                </View>

                                <View style={{ marginTop:"3" }}></View>
                                <View style={styles.containerColSquaredBorder}>

                                </View>
                                <View style={styles.col}>
                                  
                                        {/*[2,3,4].map(e => (
                                            <View style={{ borderBottom:"1" }}>
                                                <Text style={styles.containerText}>{e}</Text>
                                            </View>
                                        ))*/}
                                </View>

                            </View>
                        </Page>
                    </Document>
                  </PDFViewer>
                </div>
              
              </div>
            </div>
            <></>
          </Container>
        </Layout>
      </Transition>
    </>
  )
}

export default SabanaNotasIndex

const styles = StyleSheet.create({
  headerText: {
    fontSize:"10",
    fontFamily: "Times-Roman",
    fontWeight: "bold"
  },
  containerText: {
    fontSize:"8",
  },
  containerTextBold:{
    fontSize:"8",
    fontWeight:"bold",
  },
  col: {
    flexDirection:"column"
  },
  containerColBorder: {
    //flexDirection:"row",
    borderWidth:"1",
    padding:"4",
    borderRadius:"4"
  },
  containerColSquaredBorder: {
    borderWidth:"1",
    padding:"4",
  },
  row: {
    flexDirection:"row",
    justifyContent:"space-between"
  },
  rowCenter: {
    flexDirection:"row",
    justifyContent:"center",
    gap:"4"
  }
})